import { render } from "./TabItem.vue?vue&type=template&id=feb1e8fa"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/TabItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "feb1e8fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('feb1e8fa', __exports__)) {
    api.reload('feb1e8fa', __exports__)
  }
  
  module.hot.accept("./TabItem.vue?vue&type=template&id=feb1e8fa", () => {
    api.rerender('feb1e8fa', render)
  })

}


export default __exports__